'use client';

import NextLink from 'next/link';
import { Button } from '@heroui/react';
import { siteConfig } from '@/config/site';
import { ThemeSwitch } from '@/components/theme-switch';
import { Logo } from '@/components/icons';
import { LinkButton } from '@/components/ui/LinkButton';

export const LoggedOutNavbar = () => {
  return (
    <nav className="sticky top-0 z-40 w-full bg-background/80 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-2">
        <div className="flex items-center gap-6">
          <NextLink href="/" className="flex items-center gap-2">
            <Logo size={24} />
            <span className="font-bold">ConvoPro</span>
          </NextLink>
          <ul className="hidden items-center gap-4 lg:flex">
            {siteConfig.navItems.map((item) => (
              <li key={item.href}>
                <NextLink href={item.href} className="text-sm text-foreground/70 hover:text-foreground transition-colors">
                  {item.label}
                </NextLink>
              </li>
            ))}
          </ul>
        </div>
        <div className="flex items-center gap-2">
          <ThemeSwitch />
          <LinkButton href="/login" variant="primary">
            Login
          </LinkButton>
        </div>
      </div>
    </nav>
  );
};
